// @ts-nocheck
/* eslint-disable */
import {
  AD_NETWORK_NAME_DIMENSION,
  CAMPAIGN_ID_DIMENSION,
  CONVERSION_VALUE_DIMENSION,
  MAPPED_CONVERSION_VALUE,
  REDOWNLOAD_DIMENSION,
  SOURCE_APP_ID_DIMENSION,
} from '../../../main/screens/ScreenSKAdNetwork/ScreenSKAdNetworkConstants';
import { isActiveFlipper } from '../../../main/routers/RouterServices';
import {
  DATE_RANGE_DAY,
  DATE_RANGE_MONTH,
  DATE_RANGE_WEEK,
  LAST_ATTRIBUTED_TOUCH_DATA_TILDE_ID,
  LAST_ATTRIBUTED_TOUCH_DATA_DOLLAR_LINK_TITLE,
} from '../../../../../shared/constants/cenariusDimensions';
import { SUPPORT_APP_VERSION_IN_ANALYTICS } from '../../../../../shared/constants/flipperFlags';

const journeyCreativesTabEnabled = isActiveFlipper('journey_creatives_tab');
const supportAppVersionInAnalytics = isActiveFlipper(SUPPORT_APP_VERSION_IN_ANALYTICS);

export const FILTER_DIMENSIONS = {
  attributed: 'attributed',
  date_range: 'date',
  user_data_platform: 'platform',
  user_data_environment: 'environment',
  origin: 'origin',
  last_attributed_touch_data_tilde_creative_id: 'creative id',
  last_attributed_touch_data_tilde_tune_publisher_id: 'tune publisher id',
  last_attributed_touch_data_dollar_marketing_title: 'marketing title',
  last_attributed_touch_data_tilde_content_id: 'content id',
  last_attributed_touch_data_tilde_channel: 'channel',
  last_attributed_touch_data_tilde_organic_search_url: 'Organic Search URL',
  last_attributed_touch_data_tilde_feature: 'feature',
  last_attributed_touch_data_tilde_stage: 'stage',
  last_attributed_touch_data_tilde_tags: 'tags',
  last_attributed_touch_data_tilde_advertising_partner_name: 'ad partner',
  last_attributed_touch_data_dollar_3p: 'ad partner (3p)',
  last_attributed_touch_data_tilde_ad_name: 'ad name',
  last_attributed_touch_data_tilde_secondary_publisher: 'secondary publisher',
  last_attributed_touch_data_tilde_creative_name: 'creative name',
  last_attributed_touch_data_tilde_ad_set_name: 'ad set name',
  last_attributed_touch_data_tilde_placement: 'placement',
  last_attributed_touch_data_tilde_journey_name: 'journey name',
  last_attributed_touch_data_tilde_journey_id: 'journey id',
  last_attributed_touch_data_tilde_view_name: journeyCreativesTabEnabled ? 'journey creative name' : 'view name',
  last_attributed_touch_data_tilde_view_id: journeyCreativesTabEnabled ? 'journey creative id' : 'view id',
  last_attributed_touch_data_plus_web_format: 'web format',
  last_attributed_touch_type: 'last attributed touch type',
  [LAST_ATTRIBUTED_TOUCH_DATA_TILDE_ID]: 'link id',
  [LAST_ATTRIBUTED_TOUCH_DATA_DOLLAR_LINK_TITLE]: 'link title',
  last_attributed_touch_data_tilde_keyword: 'keyword',
  last_attributed_touch_data_plus_via_features: 'Branch feature',
  last_attributed_touch_data_tilde_customer_secondary_publisher: 'customer secondary publisher',
  last_attributed_touch_data_tilde_customer_ad_set_name: 'customer ad set name',
  last_attributed_touch_data_tilde_customer_ad_name: 'customer ad name',
  last_attributed_touch_data_tilde_customer_keyword: 'customer keyword',
  last_attributed_touch_data_tilde_customer_placement: 'customer placement',
  last_attributed_touch_data_tilde_sub_site_name: 'sub site name',
  last_attributed_touch_data_tilde_customer_sub_site_name: 'customer sub site name',
  last_attributed_touch_data_tilde_touch_subtype: 'touch subtype',
  last_attributed_touch_data_tilde_customer_campaign: 'customer campaign',
  last_attributed_touch_data_tilde_ad_id: 'ad id',
  last_attributed_touch_data_tilde_ad_set_id: 'ad set id',
  last_attributed_touch_data_tilde_campaign_id: 'campaign id',
  last_attributed_touch_data_tilde_agency_id: 'agency id',
  last_attributed_touch_data_tilde_agency: 'agency name',
  last_attributed_touch_data_tilde_campaign: 'campaign',
  last_attributed_touch_data_tilde_keyword_id: 'keyword id',
  user_data_geo_country_code: 'country',
  user_data_os: 'os',
  user_data_os_version: 'os version',
  user_data_has_app: 'has app',
  user_data_standard_events_completed: 'standard events completed',
  user_data_custom_events_completed: 'custom events completed',
  user_data_has_clicked_ad: 'has clicked ad',
  user_data_has_clicked_email: 'has clicked email',
  user_data_geo_dma_code: 'geo dma code',
  user_data_brand: 'brand',
  user_data_geo_region_en: 'region',
  name: 'name',
  customer_event_alias: 'customer event alias',
  first_event_for_user: 'first event for user',
  dismissal_source: 'dismissal source',
  user_data_app_store: 'app store',
  fraud_names: 'fraud name',
  fraud_codes: 'fraud code',
  GEO_CONFLICT: 'Geo Conflict',
  DEVICE_CONFLICT: 'Device Conflict',
  IP: 'IP',
  CONVERSION_TIME: 'Conversion Time',
  PERSONA_FRAUD: 'Persona Fraud',
  ONCE_EVER_CAPPED: 'Once Ever Capped',
  CLICK_INJECTION: 'Click Injection',
  SUSPICIOUS_DEVICE: 'Suspicious Device',
  CUSTOM: 'Custom',
  [AD_NETWORK_NAME_DIMENSION]: 'ad network',
  [CAMPAIGN_ID_DIMENSION]: 'campaign id',
  [SOURCE_APP_ID_DIMENSION]: 'source app id',
  [REDOWNLOAD_DIMENSION]: 'download type',
  [CONVERSION_VALUE_DIMENSION]: 'conversion value',
  [MAPPED_CONVERSION_VALUE]: 'mapped conversion value',
  ott: 'ott',
  cross_device_ott: 'cross device household',
  install_activity_ott: 'install activity ott',
  install_activity_cross_device_ott: 'install activity cross device household',
  reengagement_activity_ott: 'reengagement activity ott',
  reengagement_activity_cross_device_ott: 'reengagement activity cross device household',
  event_data_local_currency: 'local currency',
  [DATE_RANGE_DAY]: 'day',
  [DATE_RANGE_WEEK]: 'week',
  [DATE_RANGE_MONTH]: 'month',
  ...(supportAppVersionInAnalytics ? { user_data_app_version: 'app version' } : {}),
};

export const COHORT_USER_DATA_DIMENSIONS = {
  user_data_platform: 'platform (conversion event)',
  user_data_environment: 'environment (conversion event)',
  user_data_geo_country_code: 'country (conversion event)',
  user_data_os: 'os (conversion event)',
  user_data_has_app: 'has app (conversion event)',
  user_data_standard_events_completed: 'standard events completed (conversion event)',
  user_data_custom_events_completed: 'custom events completed (conversion event)',
  user_data_has_clicked_ad: 'has clicked ad (conversion event)',
  user_data_has_clicked_email: 'has clicked email (conversion event)',
  user_data_brand: 'brand (conversion event)',
};

export const COHORT_TYPE_AGNOSTIC_DIMENSIONS = ['user_data_app_version'];
export const INSTALL_COHORT_DIMENSIONS = {
  install_origin: 'origin',
  install_activity_touch_data_tilde_tune_publisher_id: 'tune publisher id',
  install_activity_touch_data_dollar_marketing_title: 'marketing title',
  install_activity_touch_data_tilde_content_id: 'content id',
  install_activity_attributed: 'attributed',
  install_activity_event_name: 'event name',
  install_activity_touch_type: 'type',
  install_activity_touch_data_tilde_campaign: 'campaign',
  install_activity_touch_data_tilde_channel: 'channel',
  install_activity_touch_data_tilde_feature: 'feature',
  install_activity_touch_data_tilde_stage: 'stage',
  install_activity_touch_data_tilde_tags: 'tags',
  install_activity_touch_data_tilde_advertising_partner_name: 'ad partner',
  install_activity_touch_data_dollar_3p: 'ad partner (3p)',
  install_activity_touch_data_tilde_secondary_publisher: 'secondary publisher',
  install_activity_touch_data_tilde_creative_name: 'creative name',
  install_activity_touch_data_tilde_ad_set_name: 'ad set name',
  install_activity_touch_data_tilde_ad_name: 'ad name',
  install_activity_touch_data_tilde_keyword: 'keyword',
  install_activity_touch_data_tilde_journey_name: 'journey name',
  install_activity_touch_data_tilde_view_name: 'view name',
  install_activity_touch_data_plus_referring_domain: 'referring domain',
  install_activity_touch_data_plus_via_features: 'Branch feature',
  install_activity_touch_data_plus_web_format: 'web format',
  install_activity_data_os: 'os',
  install_activity_data_environment: 'environment',
  install_activity_data_platform: 'platform',
  install_activity_data_country_code: 'country',
  install_activity_data_has_app: 'has app',
  install_activity_data_has_clicked_email: 'has clicked email',
  install_activity_data_has_clicked_ad: 'has clicked ad',
  install_activity_timezone_adjusted_day: 'date',
  install_activity_touch_data_tilde_placement: 'placement',
  install_activity_data_device_type: 'device type',
  install_activity_touch_data_tilde_sub_site_name: 'sub site name',
  install_activity_data_brand: 'brand',
  install_activity_data_geo_country_en: 'geo country',
  install_activity_data_geo_region_en: 'region',
  install_activity_touch_data_tilde_customer_secondary_publisher: 'customer secondary publisher',
  install_activity_touch_data_tilde_customer_placement: 'customer placement',
  install_activity_touch_data_tilde_customer_sub_site_name: 'customer sub site name',
  install_activity_touch_data_tilde_customer_campaign: 'customer campaign',
  install_activity_touch_data_tilde_customer_ad_set_name: 'customer ad set name',
  install_activity_touch_data_tilde_customer_ad_name: 'customer ad name',
  install_activity_touch_data_tilde_customer_keyword: 'customer keyword',
  install_activity_touch_data_tilde_agency_id: 'agency id',
  install_activity_touch_data_tilde_agency: 'agency name',
  ...(supportAppVersionInAnalytics ? { user_data_app_version: 'app version' } : {}),
};

export const REENGAGEMENT_COHORT_DIMENSIONS = {
  reengagement_activity_attributed: 'attributed',
  reengagement_activity_event_name: 'event name',
  reengagement_activity_touch_type: 'type',
  reengagement_activity_touch_data_tilde_campaign: 'campaign',
  reengagement_activity_touch_data_tilde_channel: 'channel',
  reengagement_activity_touch_data_tilde_feature: 'feature',
  reengagement_activity_touch_data_tilde_stage: 'stage',
  reengagement_activity_touch_data_tilde_tags: 'tags',
  reengagement_activity_touch_data_tilde_advertising_partner_name: 'ad partner',
  reengagement_activity_touch_data_dollar_3p: 'ad partner (3p)',
  reengagement_activity_touch_data_tilde_secondary_publisher: 'secondary publisher',
  reengagement_activity_touch_data_tilde_creative_name: 'creative name',
  reengagement_activity_touch_data_tilde_ad_set_name: 'ad set name',
  reengagement_activity_touch_data_tilde_ad_name: 'ad name',
  reengagement_activity_touch_data_tilde_keyword: 'keyword',
  reengagement_activity_touch_data_tilde_journey_name: 'journey name',
  reengagement_activity_touch_data_tilde_view_name: 'view name',
  reengagement_activity_touch_data_plus_referring_domain: 'referring domain',
  reengagement_activity_touch_data_plus_via_features: 'Branch feature',
  reengagement_activity_touch_data_plus_web_format: 'web format',
  reengagement_activity_data_os: 'os',
  reengagement_activity_data_environment: 'environment',
  reengagement_activity_data_platform: 'platform',
  reengagement_activity_data_country_code: 'country',
  reengagement_activity_data_has_app: 'has app',
  reengagement_activity_data_has_clicked_email: 'has clicked email',
  reengagement_activity_data_has_clicked_ad: 'has clicked ad',
  reengagement_activity_timezone_adjusted_day: 'date',
  reengagement_activity_touch_data_tilde_placement: 'placement',
  reengagement_activity_data_device_type: 'device type',
  reengagement_activity_touch_data_tilde_sub_site_name: 'sub site name',
  reengagement_activity_data_brand: 'brand',
  reengagement_activity_data_geo_country_en: 'geo country',
  reengagement_activity_data_geo_region_en: 'region',
  reengagement_activity_touch_data_tilde_customer_secondary_publisher: 'customer secondary publisher',
  reengagement_activity_touch_data_tilde_customer_placement: 'customer placement',
  reengagement_activity_touch_data_tilde_customer_sub_site_name: 'customer sub site name',
  reengagement_activity_touch_data_tilde_customer_campaign: 'customer campaign',
  reengagement_activity_touch_data_tilde_customer_ad_set_name: 'customer ad set name',
  reengagement_activity_touch_data_tilde_customer_ad_name: 'customer ad name',
  reengagement_activity_touch_data_tilde_customer_keyword: 'customer keyword',
  reengagement_activity_touch_data_tilde_agency_id: 'agency id',
  reengagement_activity_touch_data_tilde_agency: 'agency name',
  ...(supportAppVersionInAnalytics ? { user_data_app_version: 'app version' } : {}),
};
